var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuLogo = function SvgMenuLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11.001,
    width: 33,
    height: 8,
    rx: 4,
    fill: "#FADA50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.94c0-.657.331-1.273.887-1.623 6.85-4.3 11.124-4.54 18.237-.002.55.35.876.964.876 1.617 0 1.08-.876 1.956-1.956 1.956H7.948A1.948 1.948 0 0 1 6 4.939ZM6 24.95c0 .656.331 1.272.887 1.621 6.85 4.301 11.124 4.54 18.237.003.55-.35.876-.964.876-1.617 0-1.08-.876-1.956-1.956-1.956H7.948A1.948 1.948 0 0 0 6 24.95Z",
    fill: "#263238"
  })));
};
export default SvgMenuLogo;